export enum ComponentState {
  READY,
  SENDING,
  ERROR
}